import BorderedText from "components/bordered-text/BorderedText";
import CellBuilder from "components/cell-builder/CellBuilder";
import CustomPagination from "components/custom-pagination/CustomPagination";
import EmaButton from "components/emaButton/EmaButton";
import Loading from "components/loading/Loading";
import SliderPanel from "components/sliderPanel/SliderPanel";
import TitleBar from "layout/top-menu-bar/TitleBar";
import { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { useTranslation } from "react-i18next";
import {getElements, putElement } from "services/apiEndpoints/Endpoints";
import VehicleFilters from "view/vehicles/VehicleFilters";
import UserOperator from "./NewUser";
import useDebounce from "utils/useDebounce";
import ElipsisMenu, { MenuItem } from "components/elipsis-menu/ElipsisMenu";
import UserDetails from "./UserDetails";
const Users = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [userDetails, setUserDetails] = useState(false);
  const [users, setUsers] = useState();
  const [request, setRequest] = useState({
    limit: 50,
    offset: 1,
  });
  const [loading, setLoading] = useState(Loading);
  const { t } = useTranslation();

  const [userFilter, setUserFilter] = useState([]);
  const [searchName, setSearchName] = useState("");
  const [user, setUser] = useState({});
  const debounceSearch = useDebounce(searchName, 500);
  const getUsers = () => {
    setLoading(Loading);
    const queryStr = new URLSearchParams({
      ...request,
    }).toString();
    getElements("/Admin/User?" + queryStr)
      .then((res) => {
        setUsers(res.data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };
  useEffect(getUsers, [request]);

  const columns = [
    {
      name: "User",
      selector: (row) => CellBuilder(row.fullName),
      grow: 4,
    },
    {
      name: "Email",
      selector: (row) => CellBuilder(row.email),
      grow: 3,
    },
    {
      name: "Phone",
      selector: (row) => CellBuilder(row.phone),

      grow: 3,
    },
    {
      name: "Status",
      selector: (row) =>
        CellBuilder(
          <BorderedText
            text={row.status || ""}
            classes={row.status == "Active" ? "status_green1" : "status_orange"}
          />
        ),

      grow: 2,
    },
    {
      name: "ACTIONS",
      selector: (row) => row.actions,
      grow: 1,
    },
  ];

  const Reactivate = (id) => {
    putElement(`/Admin/User/${id}/Reactivate`).then(() => {
      getUsers();
    });
  };
  const RemoveUser = (id) => {
    putElement(`/Admin/User/${id}`).then(() => {
      getUsers();
    });
  };

  let usersData =
    userFilter &&
    userFilter.map((data) => {
      return {
        fullName: data.fullName,
        email: data.email,
        phone: data.phoneNumber,
        contact: data.email,
        status: data.status,
        actions: (
          <div className="table-actions">
            <i
              className="mil-edit-o"
              style={{ cursor: "pointer", fontSize: "21px" }}
              onClick={() => {
                setUserDetails(!userDetails);
                setUser(data);
              }}
            />
            <ElipsisMenu>
              {data.status === "Active" && (
                <MenuItem
                  title="Remove-User"
                  onClick={() => RemoveUser(data.userId)}
                />
              )}
              {data.status === "Inactive" && (
                <MenuItem
                  title="Reactivate-User"
                  onClick={() => Reactivate(data.userId)}
                />
              )}
            </ElipsisMenu>
          </div>
        ),
      };
    });
  //FILTER USEFFECT
  useEffect(() => {
    if (debounceSearch) {
      let filteredUser = users.filter((user) =>
        (user.fullName || "")
          .toLowerCase()
          .includes(debounceSearch.toLowerCase())
      );
      setUserFilter(filteredUser);
    } else {
      setUserFilter(users);
    }
  }, [debounceSearch, users]);
  return (
    <div>
      <TitleBar
        title={"Users"}
        pageOptions={
          <>
            <div
              style={{
                border: "1px solid #6B7280",
                borderRadius: "5px",
                width: "300px",
              }}
            >
              <i
                className="mil-search ml-2 mr-2 "
                style={{ color: "#6B7280" }}
              />
              <input
                type="text"
                placeholder="Search By Name"
                style={{ border: "none", outline: "none", width: "260px" }}
                className="py-1"
                onChange={(e) => setSearchName(e.target.value)}
              />
            </div>
            <EmaButton
              title={t("New User")}
              btnDark
              icon="mil-plus"
              onClick={() => setIsOpen(true)}
            />
          </>
        }
      />
      <SliderPanel setIsOpen={() => {}} isOpen={isOpen}>
        <UserOperator
          setIsOpen={setIsOpen}
          getUsers={getUsers}
          isOpen={isOpen}
        />
      </SliderPanel>

      {loading ? (
        loading
      ) : (
        <div className="summary-list">
          <DataTable
            columns={columns.map((c) => ({
              ...c,
              name: t(c.name),
            }))}
            data={usersData}
          />
          <CustomPagination
            setRequest={setRequest}
            request={request}
            nextExists={users?.length >= request.limit}
          />
        </div>
      )}
      <SliderPanel isOpen={userDetails} setIsOpen={setUserDetails}>
        <UserDetails
          setUserDetails={setUserDetails}
          user={user}
          getUsers={getUsers}
        />
      </SliderPanel>
    </div>
  );
};

export default Users;
